import React from 'react'
import { Button } from 'react-bootstrap'
import moment from 'moment'
import DateRangePickerCustom from 'components/DatePicker/DateRangePickerCustom'

const RANGE_OPTIONS = [
  { label: '1D', days: 1 },
  { label: '3D', days: 3 },
  { label: '1W', days: 7 },
]

const FormVitalSignFilter = ({ value, activeRange, onChange }) => {
  const setRange = (days) => {
    const endDate = value?.[1] ? moment(value[1]) : moment()
    const startDate = endDate.clone().subtract(days - 1, 'days')

    onChange([startDate.toDate(), endDate.toDate()], days)
  }

  const shiftRange = (direction) => {
    if (!value?.[0] || !value?.[1]) return

    const startDate = moment(value[0])
    const endDate = moment(value[1])
    const days = endDate.diff(startDate, 'days') + 1

    onChange(
      [
        startDate.clone().add(days * direction, 'days').toDate(),
        endDate.clone().add(days * direction, 'days').toDate(),
      ],
      activeRange,
    )
  }

  return (
    <div className="d-flex flex-wrap align-items-center mb-3 form-vital-sign-filter">
      <div className="form-vital-sign-date-range">
        <DateRangePickerCustom
          value={value}
          onChange={({ value: nextValue }) => onChange(nextValue, null)}
          showDefaultOptions={false}
        />
      </div>
      <div className="d-flex ml-3 form-vital-sign-range-actions">
        <Button
          aria-label="ช่วงก่อนหน้า"
          variant="outline-primary"
          className="mr-1"
          onClick={() => shiftRange(-1)}
        >
          <i className="fa fa-arrow-left" />
        </Button>
        {RANGE_OPTIONS.map(({ label, days }) => (
          <Button
            key={label}
            variant={activeRange === days ? 'primary' : 'outline-primary'}
            className="mr-1"
            onClick={() => setRange(days)}
          >
            {label}
          </Button>
        ))}
        <Button
          aria-label="ช่วงถัดไป"
          variant="outline-primary"
          onClick={() => shiftRange(1)}
        >
          <i className="fa fa-arrow-right" />
        </Button>
      </div>
    </div>
  )
}

export default FormVitalSignFilter
